import React, { useEffect, useState } from 'react';
import { BooleanInput, Filter, minValue, SearchInput, SelectInput, useNotify } from 'react-admin';
import { json, typeCampagne } from '../references.js';



const FiltreColis=(props)=>{

    const [listCamps, setListCamps] = useState();
    const [campType, setCampType] = useState('AERIEN');

    const notify = useNotify();

    useEffect(() => {

        fetch(process.env.REACT_APP_URL+'/camp/getCampagneByTypeWhereIsPrevious?camp_type='+campType, { method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            //console.log(data);
            setListCamps(data);
        }).catch((e) => {
            notify("Erreur lors de la récuperation des campagnes pour le filtre des colis!", 'warning')
        });

    }, [campType]);

    const onChange=(event)=>{
        setCampType(event.target.value);
    }
    return (
        <Filter {...props} >
            <SearchInput source="q" alwaysOn  validate={minValue(4)} />
            
            <SelectInput
                source="camp_id"
                label="Campagne" 
                choices={listCamps}
            />
            <BooleanInput  source="colis_confus"  defaultValue={true} label="Colis avec confusion"  />

            
        
       

        </Filter>
    );

}

export default FiltreColis;

/*
     <BooleanInput  source="urgent" fullWidth label="Urgent"   />
            <BooleanInput  source="rest_a_payer" label="Reste à payer"   />
            <BooleanInput  source="gratuit_excep"  label="Gratuit exceptionnel"  />
            <SelectInput
                source="client"
                label="Client" 
                choices={[
                    { id: 'cli_exp', name: 'Nom Client exp' },
                    { id: 'tel_exp', name: 'Tel Client exp' },
                    { id: 'cli_dest', name: 'Nom Client dest' },
                    { id: 'tel_dest', name: 'Tel Client dest' },
                ]}
            />
            */